import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "action-wrap" }

import {h, reactive} from "vue";
import {useRoute} from "vue-router";
import {AEditor} from "@/views/editor/service/editor";
import {LogoutOutlined, SaveOutlined, SendOutlined, SettingOutlined} from "@ant-design/icons-vue";
import FragmentOptions from "@/views/editor/components/system/FragmentOptions.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'EditorSide',
  setup(__props) {


const editor = useRoute().meta.editor as AEditor;
const info = reactive({opt: false})

/**
 create table activity.scenes(
 scene_id varchar(22) not null primary key,
 agent_id varchar(22) not null references agents(agent_id) deferrable,
 activity_id varchar(22) not null references activities(activity_id) deferrable,
 brand_id varchar(22) not null references brands(brand_id) deferrable,
 branch_id varchar(22) not null references branches(branch_id) deferrable,
 activity_employee_id varchar(22) not null references activity.employees(activity_employee_id) deferrable,
 upper_activity_customer_id varchar(22) references activity.customers(activity_customer_id) deferrable,
 attrs jsonb not null default '{}',
 unique (activity_employee_id,upper_activity_customer_id));

 create table activity.orders(
 wechat_prepay_id varchar(36) not null,
 expire_at timestamptz not null,
 transaction_id varchar(28),
 amount numeric(8,2) not null,
 wechat_profit_sharing_amount numeric(8,2) not null default 0,
 refund_amount numeric(8,2) not null default 0,
 primary key (sign_id),
 foreign key (session_id) references activity.sessions(session_id) match simple on update cascade on delete cascade deferrable) inherits (activity.signs);
 */

return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_flex, {
    vertical: "",
    justify: "space-between",
    class: "side"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_flex, {
        class: "side-logo",
        justify: "space-evenly",
        align: "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_avatar, {
            src: "/img/logo.svg",
            shape: "square",
            size: "large"
          }),
          _createVNode(_component_a_typography_text, { type: "secondary" }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("活动编辑器", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_menu, {
        items: _unref(editor).active.menu.items,
        "inline-collapsed": _unref(editor).active.menu.toggle,
        "open-keys": _unref(editor).active.menu.openKeys,
        "selected-keys": _unref(editor).active.menu.selectedKeys,
        "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((_unref(editor).active.menu.selectedKeys) = $event)),
        mode: "inline",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(editor).onMenuClick($event)))
      }, null, 8, ["items", "inline-collapsed", "open-keys", "selected-keys"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_flex, {
          vertical: "",
          gap: "middle",
          class: "action"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              size: "large",
              icon: h(_unref(SettingOutlined)),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (info.opt=true)),
              loading: _unref(editor).active.status.loading
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode(" 功能定制 ", -1)
              ]))]),
              _: 1
            }, 8, ["icon", "loading"]),
            _createVNode(_component_a_button, {
              danger: "",
              size: "large",
              icon: h(_unref(LogoutOutlined)),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/activities'))),
              loading: _unref(editor).active.status.loading
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode(" 退出编辑 ", -1)
              ]))]),
              _: 1
            }, 8, ["icon", "loading"]),
            (!_unref(editor).meta.publish_at && _unref(editor).meta.activity_id)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  size: "large",
                  icon: h(_unref(SaveOutlined)),
                  type: "default",
                  loading: _unref(editor).active.status.loading,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(editor).save()))
                }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode(" 保存活动 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["icon", "loading"]))
              : _createCommentVNode("", true),
            (!_unref(editor).meta.publish_at)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 1,
                  size: "large",
                  icon: h(_unref(SendOutlined)),
                  type: "primary",
                  loading: _unref(editor).active.status.loading,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(editor).publish()))
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("发布活动 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["icon", "loading"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_a_drawer, {
        open: info.opt,
        "onUpdate:open": _cache[6] || (_cache[6] = ($event: any) => ((info.opt) = $event)),
        title: "功能定制",
        size: "large",
        "root-style": { position: 'absolute' },
        "body-style": {padding: 0},
        "destroy-on-close": ""
      }, {
        default: _withCtx(() => [
          _createVNode(FragmentOptions)
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }))
}
}

})